module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-gray@2x-61e00b500be21b094d91f78deae8c28d.png";